var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingStatementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.552)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_6701",
    "data-name": "Rect\\xE1ngulo 6701",
    width: 30,
    height: 30,
    transform: "translate(-0.552)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19439",
    "data-name": "Trazado 19439",
    d: "M13.211,18.727a4.472,4.472,0,0,0,.514,2.208,3.58,3.58,0,0,0,1.431,1.427,4.309,4.309,0,0,0,2.107.5,4.279,4.279,0,0,0,2.231-.547,4.148,4.148,0,0,0,1.528-1.748,7.507,7.507,0,0,0,.458-.946q.2-.509.384-1.063t.357-1.121q.121-.389.255-.815a2.651,2.651,0,0,0,.141-.645.541.541,0,0,0-.155-.416.594.594,0,0,0-.423-.168.637.637,0,0,0-.479.182,2.234,2.234,0,0,0-.4.6l-.823,1.712a.631.631,0,0,1-.111.19.169.169,0,0,1-.123.056q-.179,0-.179-.248V11.761a.6.6,0,0,0-.2-.455.645.645,0,0,0-.455-.19.665.665,0,0,0-.482.19.612.612,0,0,0-.2.455v4.391q-.1-.033-.22-.067l-.233-.068V10.932a.662.662,0,0,0-1.131-.461.64.64,0,0,0-.19.461v5.025a1.879,1.879,0,0,0-.248.017q-.124.017-.248.039V11.437a.641.641,0,0,0-.2-.47.63.63,0,0,0-.46-.2.667.667,0,0,0-.664.666V16.43a1.066,1.066,0,0,0-.255.112l-.212.135V13.246a.667.667,0,0,0-.654-.656.66.66,0,0,0-.668.656Zm-1.394,7.26a3.654,3.654,0,0,1-2.683-.893,3.576,3.576,0,0,1-.9-2.645V11.19a3.573,3.573,0,0,1,.9-2.651,3.669,3.669,0,0,1,2.683-.887H22.991a3.659,3.659,0,0,1,2.677.893,3.563,3.563,0,0,1,.9,2.645v11.26a3.563,3.563,0,0,1-.9,2.645,3.657,3.657,0,0,1-2.677.893Zm-9.11-8.819V5.909a3.569,3.569,0,0,1,.9-2.649,3.669,3.669,0,0,1,2.682-.887H17.474a3.644,3.644,0,0,1,2.666.892,3.556,3.556,0,0,1,.9,2.642v.171H11.818a5.905,5.905,0,0,0-2.776.6A4.147,4.147,0,0,0,7.277,8.43a5.764,5.764,0,0,0-.614,2.76v9.517H6.288a3.645,3.645,0,0,1-2.685-.9A3.583,3.583,0,0,1,2.708,17.169Z",
    transform: "translate(0.176 0.638)",
    fill: "#885067"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingStatementIcon);
export default __webpack_public_path__ + "static/media/pendingStatementIcon.d2c76a0a76b4ae5401eb747bfc1c4b8e.svg";
export { ForwardRef as ReactComponent };